import axios from 'axios'
import router from '../router'

// function getCookie(key) {
//   var res = document.cookie.match(key + '=(.*?)($|;)')
//   if (res) {
//     return res[1]
//   }
//   return undefined
// }

// function setCookie(key, value, expires) {
//   document.cookie = key + '=' + value + ';max-age=' + expires
// }

const DEV = process.env.NODE_ENV === 'development'
let END_POINT
if (!DEV) {
  END_POINT = 'https://ma-extra-reg-form.internal.nrfc.jp/email_registration/api'
} else {
  END_POINT = 'https://ma-extra-reg-form-dev.internal.nrfc.jp/email_registration/api'
}

export default {
  getInfo(cb) {
    const ACCESS_PATH = '/forms/'
    const urlParam = router.history.current.query.code
    const apiUrl = END_POINT + ACCESS_PATH + urlParam
    const headers = {
      'Content-Type': 'application/json'
    }
    axios
      .get(apiUrl, headers)
      .then(r => {
        let res = {}
        if (r.data.error) {
          if (r.data.status === 'submitted') {
            res = 'submitted'
          } else if (r.data.status === 'expired') {
            res = 'expired'
          } else if (r.data.message === 'not available') {
            res = 'notavailable'
          }
        } else {
          res = r.data
        }
        cb(res)
      })
      .catch(error => {
        const res = 'nonexistent'
        // gtag('event', 'getInfo error', {
        //   event_label: 'getInfo:' + error,
        //   event_category: 'connect',
        //   non_interaction: true
        // })
        cb(res, error)
      })
  },
  saveInfo(email, cb) {
    const ACCESS_PATH = '/forms/'
    const urlParam = router.history.current.query.code
    const apiUrl = END_POINT + ACCESS_PATH + urlParam

    const params = {
      email: email
    }
    const headers = {
      headers: {
        'Content-Type': 'application/json'
      }
    }
    axios
      .put(apiUrl, params, headers)
      .then(res => {
        cb(res)
      })
      .catch(error => {
        if (error.response && error.response.status === 422) {
          cb(error.response)
        } else {
          // console.log('---- saveInfo error ----')
          console.log(error.response)
          // gtag('event', 'saveInfo error', {
          //   event_label: 'saveInfo:' + error,
          //   event_category: 'connect',
          //   non_interaction: true
          // })
          cb('error')
        }
      })
  }
}



// WEBPACK FOOTER //
// ./src/api/index.js